import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';
import { reduxForm, Field, FieldArray } from 'redux-form';
import _ from 'lodash';
import ReactTable from 'react-table';
import { connect } from 'react-redux';

import { InputField } from 'Common/SemanticWrapper';
import { HACCP_TYPE_FORM_NAME } from 'Common/FormEnum';
import {
  ControlInfoHACCPTypeFormEnum as Fields,
  HACCPTypeFieldEnum,
} from 'Common/FieldEnum';
import {
  ReactTableWrapperColumnProperties,
  ReactTableWrapperCogColumnProperties,
} from 'Common/Constants';
import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';
import { setNotificationDialog } from 'Components/dialogs/state/actions';
import { NOTIFICATION_DIALOG_MESSAGES } from 'Common/Constants';
import { createToast, toastType } from 'Common/ToastHelper';

import * as HACCPActions from '../state/haccp/actions';

class HACCPTypeTable extends React.Component {
  static propTypes = {
    isReadOnly: PropTypes.bool.isRequired,
  };

  menuOptions = [
    {
      icon: 'trash',
      text: 'Delete',
      className: 'danger',
      handler: row => {
        const { dispatch, fields } = this.props;

        dispatch(
          setNotificationDialog({
            ...NOTIFICATION_DIALOG_MESSAGES.REMOVE_HACCP_TYPE,
            functionsToRunOnOk: [
              async () => {
                const path = _.toPath(row);
                const index = Number(path[1]);

                const field = fields.get(index);

                if (field && field.Id) {
                  const updatedFields = fields
                    .getAll()
                    .filter((x, i) => index !== i);

                  dispatch(HACCPActions.deleteHACCPType(updatedFields));
                } else {
                  fields.remove(index);
                  createToast(
                    toastType.success,
                    'Success',
                    'Deleted HACCP Type',
                    true
                  );
                }
              },
            ],
          })
        );
      },
      disabledWhen: row => {
        return this.props.isReadOnly;
      },
    },
  ];

  render() {
    const { fields } = this.props;
    return (
      <React.Fragment>
        <ReactTable
          data={fields}
          pageSize={fields.length}
          showPageSizeOptions={false}
          showPagination={false}
          columns={[
            {
              id: 'Description',
              Header: 'Description',
              Cell: row => {
                return (
                  <Field
                    name={`${row.original}.Description`}
                    maxLength={20}
                    component={InputField}
                    fluid={true}
                    showOnlyTouchedError={true}
                    hideEmptyError={true}
                  />
                );
              },
              ...ReactTableWrapperColumnProperties,
              sortable: false,
              filterable: false,
            },
            {
              ...ReactTableWrapperCogColumnProperties,
              Cell: gridProps => {
                return GridContextMenu({
                  gridProps,
                  options: this.menuOptions,
                });
              },
            },
          ]}
        />
        <Button onClick={() => fields.push({})}>Add HACCP Type</Button>
      </React.Fragment>
    );
  }
}

HACCPTypeTable = connect()(HACCPTypeTable);

class HACCPTypeForm extends React.Component {
  static propTypes = {
    isReadOnly: PropTypes.bool.isRequired,
  };
  render() {
    const { isReadOnly } = this.props;
    return (
      <FieldArray
        name={Fields.HACCPType}
        component={HACCPTypeTable}
        isReadOnly={isReadOnly}
      />
    );
  }
}

const validate = (values, props) => {
  const errors = {};
  const HACCPTypes = values[Fields.HACCPType];

  const HACCPTypeErrors = [];

  if (Array.isArray(HACCPTypes)) {
    HACCPTypes.forEach((haccp, index) => {
      const HACCPTypeError = {};
      const description = _.get(haccp, HACCPTypeFieldEnum.Description);
      if (!description) {
        HACCPTypeError[HACCPTypeFieldEnum.Description] =
          'Description is required.';
      }
      HACCPTypeErrors[index] = HACCPTypeError;
    });
  }

  errors[Fields.HACCPType] = HACCPTypeErrors;

  return errors;
};

HACCPTypeForm = reduxForm({
  form: HACCP_TYPE_FORM_NAME,
  validate,
  destroyOnUnmount: false,
})(HACCPTypeForm);

export { HACCPTypeForm };



// WEBPACK FOOTER //
// ./src/pages/controlinformation/components/HACCPTypeForm.js